/* ========== Upsell info modal — global event delegation ========== */
(function () {
  if (window.__upsellInfoModalInit) return;
  window.__upsellInfoModalInit = true;

  /* --- FAQ accordion animation inside modals --- */
  var FAQ_DURATION = 400;

  function faqClose(details, cb) {
    var content = details.querySelector('.accordion__content');
    if (!content || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.removeAttribute('open');
      if (cb) cb();
      return;
    }
    details.classList.add('accordion--closing');
    function done() { details.removeAttribute('open'); details.classList.remove('accordion--closing'); if (cb) cb(); }
    content.addEventListener('transitionend', function h(e) {
      if (e.target !== content || e.propertyName !== 'grid-template-rows') return;
      content.removeEventListener('transitionend', h);
      done();
    });
    setTimeout(done, FAQ_DURATION + 50);
  }

  function initFaqAccordion(modal) {
    if (modal._faqInit) return;
    modal._faqInit = true;
    modal.querySelectorAll('.upsell-faq-details').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        if (details.hasAttribute('open')) {
          e.preventDefault();
          faqClose(details);
        } else {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            e.preventDefault();
            details.setAttribute('open', '');
            details.classList.add('accordion--opening-start');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                details.classList.remove('accordion--opening-start');
              });
            });
          }
        }
      });
    });
  }

  function openModal(modal, opener) {
    modal._opener = opener;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var dialog = modal.querySelector('.upsell-info-modal__dialog');
    if (dialog) dialog.focus();
    initFaqAccordion(modal);
  }


  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (modal._opener) {
      modal._opener.focus();
      modal._opener = null;
    }
  }

  function getOpenModal() {
    return document.querySelector('.upsell-info-modal[aria-hidden="false"]');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-modal-target]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-modal-target');
      var modal = document.querySelector('[data-modal-id="' + id + '"]');
      if (modal) openModal(modal, trigger);
      return;
    }

    var closer = e.target.closest('[data-modal-close]');
    if (closer) {
      var modal = closer.closest('.upsell-info-modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = getOpenModal();
      if (modal) {
        e.preventDefault();
        closeModal(modal);
      }
    }
  });
})();

if (!customElements.get('product-upsell')) {
  customElements.define(
    'product-upsell',
    class ProductUpsell extends HTMLElement {
      constructor() {
        super()
        this.boundDocumentClick = this.onDocumentClick.bind(this)
        this.boundFormSubmit = this.onFormSubmit.bind(this)
        this._savedSelections = new Map()
      }

      connectedCallback() {
        this.matchInitialVariant()
        this.initDropdowns()
        this.updateDebugBox(null)
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        )
        this.cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
          if (evt.source === 'product-form') this.reset()
        })
        document.addEventListener('click', this.boundDocumentClick)

        document.addEventListener('submit', this.boundFormSubmit, true)
      }

      matchInitialVariant() {
        const option1Index = this.getAttribute('data-initial-option1-index')
        const option1 = this.getAttribute('data-initial-option1')
        if (option1Index != null && option1Index !== '' && parseInt(option1Index, 10) >= 0) {
          this.matchProductVariants({ option1Index: parseInt(option1Index, 10) })
        } else if (option1 != null && option1 !== '') {
          this.matchProductVariants({ option1 })
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber()
        if (this.cartUpdateUnsub) this.cartUpdateUnsub()
        document.removeEventListener('click', this.boundDocumentClick)
        document.removeEventListener('submit', this.boundFormSubmit, true)
      }

      /* ========== Dropdown UI ========== */

      initDropdowns() {
        this.querySelectorAll('[data-upsell-trigger]').forEach(trigger => {
          trigger.addEventListener('click', e => {
            e.preventDefault()
            this.toggleDropdown(trigger)
          })
        })

        this.querySelectorAll('[data-upsell-item]').forEach(item => {
          item.addEventListener('click', () => this.selectItem(item))
        })

        // Auto-select default item in each *visible* group (skip optional and hidden groups)
        this.querySelectorAll('[data-upsell-group]:not([hidden])').forEach(group => {
          if (group.dataset.optional === 'true') return
          const defaultItem = group.querySelector('[data-upsell-item][data-default="true"]')
          if (defaultItem) this.selectItem(defaultItem)
        })
      }

      toggleDropdown(trigger) {
        const dropdown = trigger.closest('[data-upsell-dropdown]')
        const list = dropdown.querySelector('[data-upsell-list]')
        const isOpen = !list.hidden

        this.closeAllDropdowns()

        if (!isOpen) {
          list.hidden = false
          trigger.setAttribute('aria-expanded', 'true')
        }
      }

      closeAllDropdowns() {
        this.querySelectorAll('[data-upsell-list]').forEach(list => (list.hidden = true))
        this.querySelectorAll('[data-upsell-trigger]').forEach(trigger =>
          trigger.setAttribute('aria-expanded', 'false')
        )
      }

      onDocumentClick(e) {
        if (!e.target.closest('[data-upsell-dropdown]')) {
          this.closeAllDropdowns()
        }
      }

      /* ========== Selection ========== */

      selectItem(item) {
        const group = item.closest('[data-upsell-group]')
        const dropdown = group.querySelector('[data-upsell-dropdown]')
        const pills = group.querySelector('[data-upsell-pills]')
        const swatch = group.querySelector('[data-upsell-swatch]')
        const stack = group.querySelector('[data-upsell-stack]')
        const propertyInput = group.querySelector('[data-upsell-property]')
        const variantIdInput = group.querySelector('[data-upsell-variant-id]')

        const { title, image, variantId } = item.dataset

        // Stack: toggle off when re-clicking the selected item in an optional group
        if (stack && item.classList.contains('is-selected') && group.dataset.optional === 'true') {
          this.resetGroup(group)
          return
        }

        // Pills, Swatch, or Stack: toggle .is-selected, no trigger to update
        if (pills || swatch || stack) {
          const container = pills || swatch || stack
          container.querySelectorAll('[data-upsell-item]').forEach((el) => el.classList.remove('is-selected'))
          item.classList.add('is-selected')
          const selectedLabel = group.querySelector('[data-upsell-selected-label]')
          if (selectedLabel) {
            selectedLabel.textContent = title || ''
          }
        } else if (dropdown) {
          dropdown.querySelectorAll('[data-upsell-item]').forEach((el) => el.classList.remove('is-selected'))
          item.classList.add('is-selected')
          const trigger = dropdown.querySelector('[data-upsell-trigger]')
          const selectedImage = trigger?.querySelector('[data-upsell-selected-image]')
          const selectedText = trigger?.querySelector('[data-upsell-selected-text]')
          if (selectedImage) {
            if (image && item.dataset.matchKey) {
              selectedImage.innerHTML = `<img src="${image}" alt="${title || ''}" width="28" height="28">`
            } else {
              selectedImage.innerHTML = ''
            }
          }
          if (selectedText) selectedText.textContent = title || (group.dataset.dropdownPlaceholder || 'Select option')
          this.closeAllDropdowns()
        }

        // Update hidden property input (line item property)
        if (propertyInput) {
          if (title && item.dataset.matchKey) {
            propertyInput.value = title
            propertyInput.disabled = false
          } else {
            propertyInput.value = ''
            propertyInput.disabled = true
          }
        }

        // Store upsell variant ID
        if (variantIdInput) {
          variantIdInput.value = variantId || ''
        }

        // Persist selection keyed by property name so sibling groups
        // (same property, different material) share the choice.
        const selKey = this._selectionKey(group)
        const matchKey = (item.dataset.matchKey || '').trim()
        if (matchKey) {
          this._savedSelections.set(selKey, matchKey)
        } else {
          this._savedSelections.delete(selKey)
        }

      }

      /** Shared key for _savedSelections — uses the property input name so
       *  sibling groups for different materials share one selection. */
      _selectionKey(group) {
        const prop = group.querySelector('[data-upsell-property]')
        return prop?.name || String(Array.from(this.querySelectorAll('[data-upsell-group]')).indexOf(group))
      }

      /* ========== Variant change ========== */

      /** Get option value index (0-based) for a variant from product options JSON. */
      getOptionValueIndex(variant, optionPosition) {
        const raw = this.getAttribute('data-product-options')
        if (!raw) return -1
        let options
        try {
          options = JSON.parse(raw)
        } catch (e) {
          return -1
        }
        const opt = options.find((o) => o.position === optionPosition)
        if (!opt || !opt.values) return -1
        const value =
          (variant.options && variant.options[optionPosition - 1]) ??
          (optionPosition === 1 ? variant.option1 : optionPosition === 2 ? variant.option2 : variant.option3)
        if (value == null) return -1
        const idx = opt.values.indexOf(value)
        return idx >= 0 ? idx : -1
      }

      onVariantChange(event) {
        const variant = event.data.variant
        if (!variant) return

        this.matchProductVariants(variant)

        const allGroups = this.querySelectorAll('[data-upsell-group]')
        allGroups.forEach((group, i) => {
          const optionPosition = group.dataset.upsellOptionPosition
          const valueIndex = group.dataset.upsellValueIndex
          if (optionPosition != null && valueIndex != null) {
            const pos = parseInt(optionPosition, 10)
            const idx = parseInt(valueIndex, 10)
            const selectedIndex = this.getOptionValueIndex(variant, pos)
            group.hidden = selectedIndex !== idx
          } else {
            const optionValue = group.dataset.upsellOptionValue
            if (!optionValue) return
            const isMatch = variant.options && variant.options.includes(optionValue)
            group.hidden = !isMatch
          }

          if (group.hidden) {
            const propertyInput = group.querySelector('[data-upsell-property]')
            if (propertyInput) propertyInput.disabled = true
            return
          }

          const selKey = this._selectionKey(group)
          const savedMatchKey = this._savedSelections.get(selKey)

          let itemToSelect = null
          if (savedMatchKey) {
            itemToSelect = group.querySelector(`[data-upsell-item][data-match-key="${savedMatchKey}"]`)
          }
          if (!itemToSelect) {
            itemToSelect = group.querySelector('[data-upsell-item].is-selected')
          }
          if (itemToSelect) {
            this.selectItem(itemToSelect)
          } else if (group.dataset.optional !== 'true') {
            const defaultItem = group.querySelector('[data-upsell-item][data-default="true"]')
            if (defaultItem) this.selectItem(defaultItem)
          }
        })
        this.updateDebugBox(variant)
      }

      /** Populate debug box with current variant and per-group comparison (when data-upsell-debug-enabled). */
      updateDebugBox(variant) {
        const placeholder = this.querySelector('[data-upsell-debug-client-placeholder]')
        if (!placeholder) return

        const parts = []
        if (variant) {
          const option1Index = this.getOptionValueIndex(variant, 1)
          parts.push(
            `variant id=${variant.id} | option1=${JSON.stringify(variant.option1)} | option2=${JSON.stringify(variant.option2)} | option3=${JSON.stringify(variant.option3)} | option1Index=${option1Index} | options=${JSON.stringify(variant.options || [])}`
          )
        } else {
          const initialOption1 = this.getAttribute('data-initial-option1')
          const initialOption1Index = this.getAttribute('data-initial-option1-index')
          parts.push(`(initial) option1=${JSON.stringify(initialOption1)} | option1Index=${initialOption1Index ?? '—'}`)
        }

        this.querySelectorAll('[data-upsell-group]').forEach((group, i) => {
          const optionPosition = group.dataset.upsellOptionPosition
          const valueIndex = group.dataset.upsellValueIndex
          const optionValue = group.dataset.upsellOptionValue
          const title = group.querySelector('.upsell-group__title-main')?.textContent?.trim() || `Group ${i + 1}`

          const selectedItem = group.querySelector('[data-upsell-item].is-selected')
          const selectedMatchKey = selectedItem?.dataset?.matchKey || '(none)'
          const selKey = this._selectionKey(group)
          const savedKey = this._savedSelections.get(selKey) || '(none)'

          let line = `${title}: `
          if (optionPosition != null && valueIndex != null && variant) {
            const pos = parseInt(optionPosition, 10)
            const idx = parseInt(valueIndex, 10)
            const selectedIndex = this.getOptionValueIndex(variant, pos)
            const match = selectedIndex === idx
            line += `position=${pos} valueIndex=${idx} selectedIndex=${selectedIndex} → ${match ? 'visible' : 'HIDDEN (selectedIndex!==valueIndex)'} | group.hidden=${group.hidden}`
          } else if (optionValue != null) {
            const isMatch = variant && variant.options && variant.options.includes(optionValue)
            line += `optionValue=${JSON.stringify(optionValue)} options.includes→${isMatch} | group.hidden=${group.hidden}`
          } else {
            line += `no position/valueIndex/optionValue | group.hidden=${group.hidden}`
          }
          line += ` | matchKey=${selectedMatchKey} | savedKey=${savedKey}`
          parts.push(line)
        })

        function escapeHtml(s) {
          const div = document.createElement('div')
          div.textContent = s
          return div.innerHTML
        }
        placeholder.innerHTML = parts
          .map((p) => `<div style="margin:4px 0;">${escapeHtml(p)}</div>`)
          .join('')
      }

      normalizeOption(s) {
        if (s == null) return ''
        const str = String(s)
        const decoded = typeof document !== 'undefined' && document.createElement
          ? (function (raw) {
              const el = document.createElement('textarea')
              el.innerHTML = raw
              return el.value
            })(str)
          : str
        return decoded.replace(/\s+/g, ' ').trim().toLowerCase()
      }

      matchProductVariants(variant) {
        const productOptionsRaw = this.getAttribute('data-product-options')
        let option1Index = -1
        if (variant != null && typeof variant.option1Index === 'number' && variant.option1Index >= 0) {
          option1Index = variant.option1Index
        } else if (productOptionsRaw) {
          try {
            const options = JSON.parse(productOptionsRaw)
            const opt1 = options.find((o) => o.position === 1)
            if (opt1 && opt1.values && variant && variant.option1 != null) {
              option1Index = opt1.values.indexOf(variant.option1)
            }
          } catch (e) { /* ignore */ }
        }
        const option1 = variant ? this.normalizeOption(variant.option1) : ''

        this.querySelectorAll('[data-upsell-item][data-product-variants]').forEach(item => {
          try {
            const rawJson = item.getAttribute('data-product-variants')
            if (!rawJson) return
            const variants = JSON.parse(rawJson)
            const match =
              (option1Index >= 0 && (variants.find((v) => v.o1i === option1Index && v.a) || variants.find((v) => v.o1i === option1Index))) ||
              variants.find((v) => this.normalizeOption(v.o1) === option1 && v.a) ||
              variants.find((v) => this.normalizeOption(v.o1) === option1)
            if (match) {
              item.dataset.variantId = match.id
              item.removeAttribute('hidden')
              item.classList.remove('upsell-item--unavailable')
              if (match.p !== undefined) {
                const priceEl = item.querySelector('[data-upsell-item-price]')
                if (priceEl) priceEl.textContent = this.formatMoney(match.p)
              }
              if (match.i && !item.dataset.imageFromOption) {
                item.dataset.image = match.i
                item.querySelectorAll('img').forEach((img) => { img.src = match.i })
                const swatch = item.querySelector('.swatch')
                if (swatch) swatch.style.setProperty('--swatch--background', `url(${match.i})`)
              }
            } else {
              item.dataset.variantId = ''
              item.classList.add('upsell-item--unavailable')
              if (!item.dataset.imageFromOption) {
                item.dataset.image = ''
                item.querySelectorAll('img').forEach((img) => { img.removeAttribute('src') })
                const swatch = item.querySelector('.swatch')
                if (swatch) swatch.style.removeProperty('--swatch--background')
              }
            }
          } catch (e) { /* ignore parse errors */ }
        })
        this.syncSelectedUpsellVariantIds()
      }

      /** After variant IDs are updated, sync each group's hidden input and dropdown selected image to the selected item. */
      syncSelectedUpsellVariantIds() {
        this.querySelectorAll('[data-upsell-group]').forEach(group => {
          const variantIdInput = group.querySelector('[data-upsell-variant-id]')
          const selectedItem = group.querySelector('[data-upsell-item].is-selected')
          if (selectedItem && selectedItem.dataset.variantId && variantIdInput) {
            variantIdInput.value = selectedItem.dataset.variantId
          }
          const selectedImage = group.querySelector('[data-upsell-selected-image]')
          if (selectedImage && selectedItem && selectedItem.dataset.image) {
            selectedImage.innerHTML = `<img src="${selectedItem.dataset.image}" alt="" width="28" height="28">`
          }
        })
      }

      formatMoney(cents) {
        return Shopify.formatMoney ? Shopify.formatMoney(cents) : (cents / 100).toFixed(2)
      }

      resetGroup(group) {
        this._savedSelections.delete(this._selectionKey(group))

        const trigger = group.querySelector('[data-upsell-trigger]')
        const selectedImage = trigger?.querySelector('[data-upsell-selected-image]')
        const selectedText = trigger?.querySelector('[data-upsell-selected-text]')
        const propertyInput = group.querySelector('[data-upsell-property]')
        const variantIdInput = group.querySelector('[data-upsell-variant-id]')
        const pills = group.querySelector('[data-upsell-pills]')
        const swatch = group.querySelector('[data-upsell-swatch]')
        const stack = group.querySelector('[data-upsell-stack]')

        if (selectedImage) selectedImage.innerHTML = ''
        if (selectedText) selectedText.textContent = group.dataset.dropdownPlaceholder || 'Select option'
        if (pills || swatch || stack) {
          const container = pills || swatch || stack
          container.querySelectorAll('[data-upsell-item]').forEach((el) => el.classList.remove('is-selected'))
        }
        const selectedLabel = group.querySelector('[data-upsell-selected-label]')
        if (selectedLabel) selectedLabel.textContent = ''
        if (propertyInput) {
          propertyInput.value = ''
          propertyInput.disabled = true
        }
        if (variantIdInput) variantIdInput.value = ''
      }

      /** Reset all upsell selections (no values retained). Call after successful add to cart. */
      reset() {
        this.querySelectorAll('[data-upsell-group]').forEach((group) => this.resetGroup(group))
      }

      /* ========== Cart integration ========== */

      /** Returns an array of selected variant IDs from this element's visible upsell groups. */
      getActiveUpsellVariantIds() {
        const ids = []
        this.querySelectorAll('[data-upsell-group]:not([hidden])').forEach((group) => {
          const input = group.querySelector('[data-upsell-variant-id]')
          const value = input?.value?.trim()
          if (value) ids.push(parseInt(value, 10))
        })
        return ids.filter((id) => !Number.isNaN(id))
      }

      /** Returns all selected upsell variant IDs from every product-upsell in the section (for form submit). */
      getAllSectionUpsellVariantIds() {
        const section = this.closest('section')
        if (!section) return this.getActiveUpsellVariantIds()
        const ids = []
        section.querySelectorAll('product-upsell').forEach((el) => {
          if (typeof el.getActiveUpsellVariantIds === 'function') {
            ids.push(...el.getActiveUpsellVariantIds())
          }
        })
        return [...new Set(ids)]
      }

      /** Returns upsell line items with properties. Variant (match_key) goes on the upsell item when group has add_match_key_to_cart. */
      getAllSectionUpsellItems() {
        const section = this.closest('section')
        if (!section) return this.getActiveUpsellItems()
        const items = []
        const seenIds = new Set()
        section.querySelectorAll('product-upsell').forEach((el) => {
          if (typeof el.getActiveUpsellItems === 'function') {
            el.getActiveUpsellItems().forEach((item) => {
              if (!seenIds.has(item.id)) {
                seenIds.add(item.id)
                items.push(item)
              }
            })
          }
        })
        return items
      }

      /** Returns [{ id, quantity, properties? }] for this element's selected upsells. Variant property on item when group has add_match_key_to_cart. */
      getActiveUpsellItems() {
        const items = []
        this.querySelectorAll('[data-upsell-group]:not([hidden])').forEach((group) => {
          const variantIdInput = group.querySelector('[data-upsell-variant-id]')
          const variantId = parseInt(variantIdInput?.value?.trim() || '', 10)
          if (!variantId || Number.isNaN(variantId)) return
          const selected = group.querySelector('[data-upsell-item].is-selected')
          const addMatchKey = group.dataset.addMatchKeyToCart === 'true'
          const matchKey = addMatchKey && selected?.dataset?.matchKey?.trim()
          const item = { id: variantId, quantity: 1 }
          if (matchKey) item.properties = { Variant: matchKey }
          items.push(item)
        })
        return items
      }

      /** Returns the first selected upsell variant ID (for backward compatibility with optional-file-input, etc.). */
      getActiveUpsellVariantId() {
        const ids = this.getActiveUpsellVariantIds()
        return ids.length > 0 ? ids[0].toString() : null
      }

      onFormSubmit(e) {
        const form = e.target
        if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return

        const section = this.closest('section')
        if (!section || !section.contains(form)) return

        const validation = CartAdd.validateInputModal(section, form)
        if (!validation.valid) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation()
          validation.inputModal.openAndShowErrors(validation.invalidFields)
          return
        }

        // Includes charm-picker selections from input modals (CartAdd.getCharmItems)
        const upsellItems = CartAdd.getUpsellItems(section)
        if (upsellItems.length === 0) return

        const optionalFileItem = CartAdd.getOptionalFileItem(section)
        const hasFile = CartAdd.optionalFileHasFile(section)

        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()

        const productFormEl = form.closest('product-form')
        const submitButton = productFormEl?.querySelector('[type="submit"]')
        const cart = CartAdd.getCart()

        CartAdd.setButtonLoading(submitButton, productFormEl, true)

        const formData = new FormData(form)
        const mainVariantId = formData.get('id')
        const quantity = parseInt(formData.get('quantity') || '1', 10)

        const properties = CartAdd.buildMainProperties(formData, {
          section,
          skipEngravingWhenNo: true,
          skipUpsellGroupProps: true,
        })
        const mainItem = { id: parseInt(mainVariantId, 10), quantity }
        if (Object.keys(properties).length > 0) mainItem.properties = properties

        const { sections, sectionsUrl } = CartAdd.getSectionsConfig(cart)
        if (cart) cart.setActiveElement(document.activeElement)

        const finish = (response) => {
          CartAdd.handleResponse(response, {
            cart, productFormEl, mainVariantId,
            onSuccess: () => {
              section.querySelectorAll('product-upsell').forEach(el => {
                if (typeof el.reset === 'function') el.reset()
              })
            },
          })
        }
        const finallyCb = () => CartAdd.setButtonLoading(submitButton, productFormEl, false)

        if (hasFile) {
          const engravingNo = CartAdd.isEngravingNo(section)
          const addFormData = new FormData()
          for (const [key, value] of new FormData(form).entries()) {
            if (key.startsWith('properties[') && key.includes('Engraving -') && engravingNo)
              continue
            addFormData.append(key, value)
          }
          addFormData.append('sections', sections.join(','))
          addFormData.append('sections_url', sectionsUrl)
          CartAdd.postFormData(addFormData)
            .then(response => {
              if (response.status) { finish(response); return }
              const extraItems = [...upsellItems]
              if (optionalFileItem) extraItems.push(optionalFileItem)
              return CartAdd.postJSON(extraItems, sections, sectionsUrl)
            })
            .then(linked => { if (linked) finish(linked) })
            .catch(console.error)
            .finally(finallyCb)
          return
        }

        const items = [...upsellItems]
        if (optionalFileItem) items.push(optionalFileItem)
        items.push(mainItem)

        CartAdd.postJSON(items, sections, sectionsUrl)
          .then(finish)
          .catch(console.error)
          .finally(finallyCb)
      }
    }
  )
}
